<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="auth_requestor_tooltip_name"
      :name="auth_requestor_tooltip_name" :description="auth_requestor_tooltip_description"
      :editable="editable"></tool-tip>

    <div class="row justify-content-center">
      <!-- <div v-if="duringSubmit" class="loading">
        <Loading/>
      </div> -->
      <div class="col-sm-6 content_padding_top">

        <label for="name"> Name (Last, First, MI, Rank / Title)</label>
        <base-input id="name" :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
          v-model="authorizedRequestor.requestorName" name="authorizedRequestorName" data-vv-as="Name"
          v-validate="'required|max:300'" :error="getError('authorizedRequestorName')">
        </base-input>
      </div>
      <div class="col-sm-6 content_padding_top">
        <label for="requestingOffice">Requesting Unit / Office</label>
        <base-input id="requestingOffice" :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
          v-model="authorizedRequestor.requestorUnitOffice" data-vv-as="Requesting Unit / Office"
          name="requestingUnitOffice" v-validate="'required|max:300'" :error="getError('requestingUnitOffice')">
        </base-input>
      </div>
      <div class="col-sm-6 content_padding_top">
        <label for="requestingNation">Requesting Nation / Organization</label>
       
        <v-select id="requestingNation" :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
          v-model="authorizedRequestor.requestorOrganizationId" :reduce="(organizationOption) => organizationOption.id"
          :options="authorizedRequestor.organizations" label="name" placeholder="Select one"
          name="requestingNationOrganization" data-vv-as="Requesting Nation / Organization"
          :class="errors.has('requestingNationOrganization') ? 'has-danger' : ''" v-validate="'required'"
          :error="getError('requestingNationOrganization')"></v-select>
        <span v-show="errors.has('requestingNationOrganization')" class="error">Requesting Nation / Organization is
          required
        </span>
      </div>
       
      <div class="col-sm-6 content_padding_top">
      <verify-pin v-if="isSigned" :checkForPartnerNationCondition="checkForPartnerNationCondition" :isPartnerAccount="isPartnerAccount" :isReadOnly="isReadOnly" v-on:pinVerify="pinVerify"/>
        <AlertSignature ref="alertAuthorizedRequestorSignatureGraphical" :headerText="'Authorized Requestor Signature'"
          :module="'authorizedRequestor'" :action="'getAuthorizedRequestor'"
          v-on:onUpload="fileUploaded"
          v-on:onSigned="onSigned"
          activeTab="TEXT" :signatureData="authorizedRequestor.requestorSignature"
          :isPinVerified="isPinVerificationDone"
          :fileTypeId="1" :textDisabled="checkForPartnerNationCondition || isAuthorized || isReadOnly"
          :drawDisabled="checkForPartnerNationCondition || isAuthorized || isReadOnly"
          :uploadDisabled="isPartnerAccount || isAuthorized || isReadOnly"
          :certificateDisabled="isPartnerAccount || isAuthorized || isReadOnly || !signedInWithCac" />

        <label style="margin-left: 5px; margin-right: 5px" v-if="!isBuyTransaction  && !isPartnerAccount">or</label>
        <request-signature :signatureUrl="`api/requestorsignatures/request/${getOrderIdFromRoute}`"
          :requestDate="requestedDate" :isDisabled="isRequestDisabled || refreshKey > 0 "
          v-bind:moduleSubmit="submit"
          @update-status="updateStatus"
          v-if="!isBuyTransaction  && !isPartnerAccount"></request-signature>
        <div v-if="hasSignatureImage()" class="container signature_content_padding_top_small signature_field">
          <div class="row justify-content-end">
            <delete-signature
            :headerText="'Are you sure you want to remove the Requestor Signature?'" 
            :signatureId="authorizedRequestor.requestorSignature.signatureId"
             :fileTypeId="1"
            :signatureType="authorizedRequestor.requestorSignature.type"
            :disabled="isPartnerAccount || isAuthorized"
            v-on:modal-closed="reloadData"></delete-signature>
          </div>

          <img class="image_layout" :src="authorizedRequestor.requestorSignature.view" height="100" />
        </div>

        <div class="signature_content_padding_top_small">
          <label for="signatureDate">Signature Date</label>
          <el-date-picker id="signatureDate"
            :disabled="(isAuthorized && !isLegacyOrder) || isReadOnly || isPartnerAccount || (!isRelevantDocumentUploaded && !fileUploadedBoolean && !uploadedStatus)"
            v-model="authorizedRequestor.requestorDateSigned" type="date" :editable="false" format="dd-MMMM-yyyy"
            data-vv-as="Signature Date" name="dateSigned" :class="errors.has('dateSigned') ? 'has-danger' : ''"
            :error="getError('dateSigned')">
          </el-date-picker>
          <span v-show="errors.has('dateSigned')" class="error">Signature Date is required
          </span>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 signature_content_padding_top">
        <div class="pull-right">
          <base-button type="primary" wide :disabled="isReadOnly || isAuthorized || checkForPartnerNationCondition"
            @click.native="submit" class="btn-next">Save</base-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import RequestSignature from "@/components/App/signatures/RequestSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import { mapGetters, mapActions } from "vuex";
import { Button } from "element-ui";
import Util from "@/util/util";
import Loading from 'src/components/LoadingPanel';
import toolTip from "../../../Tooltip";
import { EventBus } from "@/event-bus.js";
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { event } from 'd3';


export default {
  props: ["isReadOnly", "uploadedStatus"],
  name: "AuthorizedRequestorAuthorize",
  data() {
    return {
      isBuyTransaction: true,
      duringSubmit: false,
      auth_requestor_tooltip_description: '',
      auth_requestor_tooltip_name: '',
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      sigHasSigned: false,
      refreshKey: 0,
      requestedDate: null,
    };
  },

  components: {
    AlertSignature,
    RequestSignature,
    DeleteSignature,
    [Button.name]: Button,
    Loading,
    toolTip,
    VerifyPin
  },
  async mounted() {
    // Load organizations first so dropdown options are available when the saved value is loaded
    await this.loaded();
    
    await this.getAllTooltips();
    this.loadToolTips();

    EventBus.$on('pn-user-change', async (value) => {
      this.loadAuthorizedRequestor(this.getOrderIdFromRoute);
    });
  },
  computed: {
    ...mapGetters({
      authorizedRequestor: "authorizedRequestor/authorizedRequestor", // Authorize Tab
      getUser: "authentication/getUser",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus:
        "agreementInformation/agreementInformationStatus",
      authorizedRequestorHelper: "authorizedRequestor/authorizedRequestorHelper",
      documents: "documents/getDocuments",
      orderMetadata: "orderMetadata/orderMetadata",
      authorizedRequestorErrors: "authorizedRequestor/authorizedRequestorErrors",
      isPartnerAccount: "authentication/isPartnerAccount",
      isAuthorized: "orderMetadata/isAuthorized",
      isSubmitted: "orderMetadata/isSubmitted",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
     isSigned() {
      if(this.authorizedRequestor.requestorDateRequested){
        if(!this.authorizedRequestor.requestorSignature.signatureId){
          return true
        }else return false
      }else return false
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    checkForPartnerNationCondition() {
      if (this.isPartnerAccount && this.isUsSellOrder) {
        if (this.authorizedRequestor.requestorDateRequested == null)
        {
          return true;
        }
          return false;
      } else if (this.isPartnerAccount && this.isUsBuyOrder) {
        return true;
        }
    },
    isRequestDisabled() {
      this.refreshKey;
      this.requestedDate = this.authorizedRequestor.requestorDateRequested;
      return !this.authorizedRequestor.requestorName || !this.authorizedRequestor.requestorUnitOffice || !this.authorizedRequestor.requestorOrganizationId
        || this.authorizedRequestor.requestorDateRequested ? true : false || this.authorizedRequestor.requestorSignature.view ? true : false || !this.isSubmitted || this.isReadOnly

    },
      isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    signedInWithCac() {
      return this.getUser.loginMethod == "CAC";
    },
    isRelevantDocumentUploaded() {
      if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === Util.TRANSACTION_AUTHORIZATION);
        });
      }
      this.fileUploadedBoolean = false;
      this.$emit('no-document-file-requestor');
      return false
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },
  methods: {
    ...mapActions({
      loadAuthorizedRequestor: "authorizedRequestor/getAuthorizedRequestor",
      getAuthorizedRequestorAuthorizeStatus:
        "authorizedRequestor/getAuthorizedRequestorAuthorizeStatus",
      getAuthorizedRequestorHelper:
        "authorizedRequestor/getAuthorizedRequestorHelper",
      saveAuthorizedRequestorToServer: "authorizedRequestor/saveAuthorizedRequestor",
      getAllTooltips: "tooltip/getToolTips",
      getAuthorizedRequestorSigOnly: "authorizedRequestor/getAuthorizedRequestorSigOnly"
    }),
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'TRANSACTION AUTHORIZATION')
    },
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this
        this.pin = null;
    },
    updateStatus() {
      this.refreshKey++;
    },
    async fileUploaded() {
      this.fileUploadedBoolean = true;
      this.$emit('transaction-file-uploaded', true);
      await this.getAuthorizedRequestorSigOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();

    },
    loadToolTips() {
      const authRequestorToolTip = this.toolTips.find(e => e.name === "AuthRequestorSignature")
      if (authRequestorToolTip.status) {
        this.auth_requestor_tooltip_description = authRequestorToolTip.description ? authRequestorToolTip.description : null
        this.auth_requestor_tooltip_name = authRequestorToolTip.name ? authRequestorToolTip.name : null
      }
      return
    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },
    async loaded() {
      let ctx = this;

      await ctx.getAuthorizedRequestorHelper(ctx.getOrderIdFromRoute);
      
      const params = {
        buySell: ctx.authorizedRequestorHelper.buySell,
        countryId: ctx.authorizedRequestorHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      this.isBuyTransaction = params.buySell == "BUY";

      await ctx.$store.dispatch(
        "authorizedRequestor/getOrganizations",
        params
      );
      
      await ctx.loadAuthorizedRequestor(ctx.getOrderIdFromRoute);
    },

    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.authorizedRequestor.requestorSignature.view);
    },
    async reloadData() {
      await this.getAuthorizedRequestorAuthorizeStatus(this.getOrderIdFromRoute);
            await this.loadAuthorizedRequestor(this.getOrderIdFromRoute);
    },

    async submit(e) {
      var result = await this.$validator.validateAll();
      if (result) {
        this.$loaderApp.addRequest();
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded && this.authorizedRequestor.dateSigned) {
          this.authorizedRequestor.dateSigned = null;
          //this.duringSubmit = false;
          this.$loaderApp.completeRequest();
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        } else {
          try {
            let ctx = this;
            let data = {
              orderId: this.getOrderIdFromRoute,
              pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
            }
            await this.saveAuthorizedRequestorToServer(data);
            await this.getAuthorizedRequestorAuthorizeStatus(ctx.getOrderIdFromRoute);
            ctx.$toast.success("Authorized Requestor Module signature saved successfully");
            
            // do we need this?
            await ctx.loadAuthorizedRequestor(ctx.getOrderIdFromRoute);
            this.$loaderApp.completeRequest();

          } catch (errorMessage) {
            this.$loaderApp.completeRequest();
            this.$toast.error(errorMessage);
          }
        }
        this.$loaderApp.completeRequest();
      } else {
        //this.duringSubmit = false;
        this.$loaderApp.completeRequest();
        this.$toast.error("Please fill the form required fields.");
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
 };
</script>

<style scopped>
.row {
    margin-right: 0px!important;
    margin-left: 0px!important;
}
</style>